export default __webpack_public_path__ + "assets/skills-manager-error-5646efaf559ef03a471ba350bb9c5500.png";